// src/api/auth.js
import { apiJson } from "./client";

// 백엔드가 /auth/login 을 받는다는 전제
export function login(email, password) {
    return apiJson("/auth/login", {
        method: "POST",
        body: { email, password },
    });
}
